import { render, staticRenderFns } from "./langauge-question.vue?vue&type=template&id=40c3007c"
import script from "./langauge-question.vue?vue&type=script&lang=js"
export * from "./langauge-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports